// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__-tAJx","logo":"MainNavigation_logo__VpU3t","active":"MainNavigation_active__KjKvx","badge":"MainNavigation_badge__+1oSo"};